import * as React from "react";
import { CreatedColumn } from "../../newcomponents/table/columns/wellKnown/createdColumn";
import { LastModifiedColumn } from "../../newcomponents/table/columns/wellKnown/lastModifiedColumn";
import { Table } from "../../newcomponents/table/table";
import { useTableItemQueryData } from "../../newcomponents/table/data/useTableItemQueryData";
import { useTableKindId } from "../../newcomponents/table/data/useTableKindId";
import { TableNewItemButton } from "../../newcomponents/table/components/tableNewButton";
import { TableHeaderRefreshButton } from "../../newcomponents/table/components/RefreshButton";
import { CustomTableCPLNQuery } from "../../newcomponents/table/components/TableCplnQuery";
import { TableActionsDropdown } from "../../newcomponents/table/components/tableActionsDropdown";
import { NameDescriptionColumn } from "../../newcomponents/table/columns/wellKnown/nameDescriptionColumn";
import { GvcBulkDeleteModal } from "./gvcBulkDeleteModal";
import { TagsColumn } from "../../newcomponents/table/columns/wellKnown/tagsColumn";
import { useColumnsWithTagColumns } from "../../newcomponents/table/columns/tagColumns/useColumnsWithTagColumns";
import { linksOf } from "../../services/cpln";
import { Gvc } from "../../schema/types/gvc/entity";
import { GvcTableItem } from "../../mst/kinds/gvc.helpers";

export const GvcList: React.FC = () => {
  const [selectedLinks, setSelectedLinks] = React.useState<string[]>([]);
  const [action, setAction] = React.useState<string>("");

  const { kind, id } = useTableKindId("gvc", "gvc-list");
  const qData = useTableItemQueryData<Gvc>(kind, {});
  const columns = useColumnsWithTagColumns<GvcTableItem>(
    [NameDescriptionColumn(), TagsColumn(), CreatedColumn(), LastModifiedColumn()],
    kind,
  );

  const gvcTableItems: GvcTableItem[] = qData.visibleItems.map((gvc) => {
    const selfLink = linksOf(gvc).self!;

    return {
      ...gvc,
      selfLink: selfLink,
    };
  });

  return (
    <>
      <Table<GvcTableItem>
        title={"GVCs"}
        data={gvcTableItems}
        selectKey="selfLink"
        selectMode="multi"
        selections={selectedLinks}
        onSelectionsChange={setSelectedLinks}
        tableId={id}
        headerRenderer={() => {
          return (
            <>
              <TableNewItemButton kind={kind} />
              <TableActionsDropdown
                kind={kind}
                selectionLinks={selectedLinks}
                options={[
                  {
                    key: "delete",
                    label: "Delete",
                    disabled: selectedLinks.length < 1,
                    danger: true,
                    callback: () => setAction("delete"),
                  },
                ]}
              />
              <TableHeaderRefreshButton onClick={qData.refetch} />
              <CustomTableCPLNQuery
                tableId={id}
                kind={kind}
                onQuery={qData.setCplnQuery}
                isLoading={qData.isLoading}
              />
            </>
          );
        }}
        enableFilter
        isLoading={qData.isLoading}
        onSortChange={qData.setSort}
        onSearchChange={qData.setSearch}
        isLoadingMore={qData.isLoadingMore}
        hasMore={qData.hasMore}
        onLoadMore={qData.fetchNextPage}
        columns={columns}
      />
      {action === "delete" ? (
        <GvcBulkDeleteModal
          links={selectedLinks}
          onCancel={() => setAction("")}
          onComplete={() => {
            setAction("");
            setSelectedLinks([]);
            qData.refetch();
          }}
        />
      ) : null}
    </>
  );
};
